import { render, staticRenderFns } from "./drawer-settings.vue?vue&type=template&id=1b0881d5&"
import script from "./drawer-settings.vue?vue&type=script&lang=js&"
export * from "./drawer-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports